export default __webpack_public_path__ + "static/media/1.0719d1c2.jpg";